import { Component, HostListener, Inject, Injectable, isDevMode, OnInit, Output, ViewEncapsulation, EventEmitter, Input, Injector, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Vehicle } from '../../../../../models/vehicles/vehicle';
import { debounceTime, filter, Observable, of, ReplaySubject, take } from 'rxjs';
import { ExpedientFilters } from 'src/app/models/expedients/expedient-filters';
import { CommonService } from 'src/app/services/api/common.service';
import { MasterService } from 'src/app/services/api/masters.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { StorageService } from 'src/app/services/utils/storage.service';

import { CanDeactivate, Router } from '@angular/router';
import { EmptyKeyValue, KeyValue } from 'src/app/models/key-value';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { Purchase } from 'src/app/models/expedients/purchase';
import { Document } from 'src/app/models/documents/document';
import { MasterCommon } from 'src/app/models/masters/master-common';
import { DocumentService } from 'src/app/services/api/document.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DocFilters } from 'src/app/models/documents/doc-filters';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { stagger40ms } from 'src/@vex/animations/stagger.animation';
import { animate, state, style, transition, trigger } from '@angular/animations';
import messagesJson from 'src/assets/messages/documentation-reports.json';
import { Entity } from 'src/app/models/contacts/entity';
import { Base64 } from 'src/app/models/documents/base64';
import { CommonListResponse } from 'src/app/models/common-list-response';
import { ReportsHistoryTableComponent } from './reports-history-table/reports-history-table.component';

@Component({
  selector: 'vex-documentation-report',
  templateUrl: './documentation-report.component.html',
  styleUrls: ['./documentation-report.component.scss'],
  animations: [
      fadeInUp400ms,
      stagger40ms,
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({
          height: '*',
          minHeight: ''
        })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ])
    ],
})
export class DocumentationReportComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    private router: Router,
    private dialogRef: MatDialogRef<DocumentationReportComponent>,
    private fb: FormBuilder,
    private injector: Injector,
    private dialog: MatDialog,
    private alert: ToastService,
    private documentService: DocumentService,
    private commonService: CommonService<Purchase, ExpedientFilters>,
    private masterService: MasterService<MasterCommon>,
    private storageService: StorageService) {
      this.dataSource = new MatTableDataSource();
      this.vehiclesDataSource = new MatTableDataSource();
    }

  messages = messagesJson.messages;

  service: string = 'documents/report';
  documents: Document[];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  vehiclesDataSource: MatTableDataSource<any> = new MatTableDataSource();
  expandedElement: Document | null;
  anySelect: boolean = false;

  vehicles: Array<Vehicle> = [];
  contacts: Array<any> = [];
  client: Array<any> = [];
  broker: Array<any> = [];
  user: string = '';
  userContact: string = '';
  clientLanguage: string = '';
  clientMessage: { language: string; message: string };
  languages: string[] = [];
  brokerList: Array<KeyValue>;

  uniqueSelect?: boolean;
  allSelected: boolean = true;
  selection = new SelectionModel<any>(true, []);
  docVehicleSelection: Map<number, Set<number>> = new Map();
  tableData?: Array<any>; 
  items: any[] = [];
  subject$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  data$: Observable<any[]> = this.subject$.asObservable();
  searchCtrl = new UntypedFormControl();
  columns: TableColumn<Document>[];
  vehicleColumns: TableColumn<Vehicle>[];
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 20, 50];
  filters: DocFilters = new DocFilters();
  paginatedOnBack?: boolean;
  order = "desc";
  orderType = "";

  form: FormGroup;

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  get visibleVehicleColumns() {
    return this.vehicleColumns.filter(column => column.visible).map(column => column.property);
  }

  ngOnInit(): void {

    (async () => {
      
      this.loadForm();
      this.loadData();

      this.columns = [
        { label: ' ', property: 'expandIni', type: 'expand', visible: true },
        { label: 'Casilla de selección', property: 'checkbox', type: 'checkbox', visible: true },
        { label: 'Nombre', property: 'name', type: 'text', visible: true, },
        { label: 'Categoría', property: 'documentCategory', type: 'select', visible: true },
        { label: 'Fecha de subida', property: 'createdAt', type: 'date', visible: true },
        { label: 'En el coche', property: 'insideCar', type: 'flag', visible: true },
      ];

      this.vehicleColumns = [
        { label: 'Sel.', property: 'vehicleSelect', type: 'vehicleSelect' as any, visible: true },
        { label: 'Ant.', property: 'prevReport', type: 'vehiclePrevReport' as any, visible: true },
        { label: 'Bastidor', property: 'vin', type: 'text', visible: true, },
        { label: 'Marca', property: 'brand', type: 'select', visible: true },
        { label: 'Modelo', property: 'model', type: 'select', visible: true },
        { label: 'Versión', property: 'version', type: 'select', visible: true },
        { label: 'Asociado', property: 'createdAt', type: 'date', visible: true },
      ];

      const entities = await this.masterService.getAll("entities") as unknown as Array<Entity>;
      this.brokerList = entities.filter(x => x.entityType?.name == 'Broker').map(x => new KeyValue(x));

      this.selectionHasValue()

      this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => this.selectionHasValue());

    })();
  }

  loadData() {
    this.loadFilters();
    this.getData();

    this.dataSource = new MatTableDataSource();
    this.vehiclesDataSource = new MatTableDataSource();

    this.data$.pipe(
      filter<any[]>(Boolean)
    ).subscribe(items => {
      this.items = items;
      this.dataSource.data = this.items;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sortingDataAccessor = (obj: any, property: string) =>
        property.split('.').reduce((o, p) => o && o[p], obj);
      this.dataSource.sort = this.sort;

      this.initVehicleSelections(this.items);
      this.selection.clear();

      if (this.allSelected) {
        this.dataSource.data.forEach(row => {

          if (row.exist) this.selection.select(row)
        });
      }

      this.selectionHasValue();
    });

    this.searchCtrl.valueChanges.subscribe(value => this.onFilterChange(value));
  }

  getData() {
    this.documentService.get(this.service, this.filters).subscribe({
      next: response => {
        if (!response) {
          this.alert.error("No hay documentos");
        } else if (!response.isSuccessful) {
          this.alert.info(response.message);
        } else {
          this.documents = response.data['documents'].map(d => new Document(d));
          this.paginator.length = response.total;
          this.paginator.pageIndex = this.pageIndex;
          this.subject$.next(this.documents);

          this.contacts = response.data['client'];
          this.client = response.data['client'];
          this.broker = response.data['brokers'];
          this.user = response.data['user']?.email;

          this.clientLanguage = this.contacts[0]?.language?.name || 'en';

          this.clientMessage = this.messages.find(
            msg => msg.language === this.clientLanguage
          );

          if (!this.clientMessage) {
            this.clientMessage = { language: 'en', message: '' };

          } else {
            this.clientMessage.message.replace('{tracking}', this.form.get('tracking').value);
          }

          this.form.patchValue({
            tracking: '',
            user: this.user,
            receiver: this.client[0]?.email,
            sendMessage: this.clientMessage.message,
          });

        }
      },
      error: e => {
        if (e.status === 401) {
          this.router.navigate(['/login']);
          this.alert.info("Sesión expirada");
          return;
        }
        if (isDevMode) {
          this.alert.error(e.message);
        } else {
          this.alert.error("No ha sido posible recuperar la lista de documentos");
        }
      }
    });
  }

  loadFilters() {
    this.filters.pageNumber = this.pageIndex + 1;
    this.filters.rowsPerPage = this.pageSize;
    this.filters.referenceId = this.defaults.values;
    this.filters.order = this.order;
    this.filters.orderBy = this.orderType;
  }

  loadForm() {
    this.form = this.fb.group({
      tracking: ['', [Validators.required, Validators.pattern(/\S/)]], // EEC-121: required acepta solo espacios
      user: ['', Validators.required],
      receiver: ['', Validators.required],
      sendMessage: ['', Validators.required],
    });
  }

  loadVehicles(element: Document, expandedElement: Document) {
    if (expandedElement && element.id === expandedElement.id) {
      const vehicles = element.vehicles || [];
      this.vehiclesDataSource.data = vehicles;
    }
  }

  selectFile(row: any) {
    if (this.uniqueSelect) {
      this.unselectRows()
    }
    this.selection.toggle(row);
    // EEC-118: el detalle de vehículos sigue al documento. Desmarcarlo vacía sus
    // vehículos; volver a marcarlo los marca todos (el estado inicial del modal).
    this.syncVehiclesWithDocument(row);
    this.selectionHasValue();
  }

  /** EEC-118: alinea `docVehicleSelection` con si el documento está marcado o no. */
  private syncVehiclesWithDocument(doc: any) {
    if (!doc || !doc.id || !doc.vehicles) return;
    this.docVehicleSelection.set(doc.id, new Set(
      this.selection.isSelected(doc) ? (doc.vehicles as any[]).map(v => v.id) : []
    ));
  }

  unselectRows() {
    let total = this.dataSource.data.length;
    let initIndex: number = 0;
    if (this.pageIndex > 0) {
      initIndex = (this.pageIndex) * this.pageSize;
      total = this.pageSize * (this.pageIndex + 1);
    }
    for (let index = initIndex; index < total; index++) {
      if (this.dataSource.data[index]) {
        this.selection.deselect(this.dataSource.data[index])
        this.syncVehiclesWithDocument(this.dataSource.data[index]);
      }
    }
  }

  changeReceiver(check: boolean) {
    if (check) {
      if (this.broker.length > 0) {
        this.form.get('receiver').setValue(this.broker[0].email);
        this.contacts = this.broker;

      } else {
        this.form.get('receiver').setValue(null);
        this.contacts = this.brokerList;
      }
    } else {
      this.form.get('receiver').setValue(this.client[0].email);
      this.contacts = this.client;
    }

    this.clientLanguage = this.contacts[0]?.language?.name || 'en';

    this.clientMessage = this.messages.find(
      msg => msg.language === this.clientLanguage
    );
  }

  replaceTracking() {

    this.clientMessage = this.messages.find(
      msg => msg.language === this.clientLanguage
    );

    let message = this.clientMessage.message.replace('{tracking}', this.form.get('tracking').value);

    this.form.patchValue({
      sendMessage: message,
    });
  }

  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    value = value.trim();
    value = value.toLowerCase();
   
    this.dataSource.filter = value;
  }

  sortData(event) {
    this.orderType = event.active;
    this.order = event.direction;
    this.loadData();
  }

  onPaginateChange(event) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    const top = document.getElementById('top');
    top.scrollIntoView();
  }

  changeInsideCar(row, event) {
    const index = this.documents.findIndex(doc => doc.id === row.id);
    this.documents[index].insideCar = !event;
  }

  trackByProperty(index: number, column: any): string {
    return column?.property;
  }

  initVehicleSelections(docs: any[]) {
    this.docVehicleSelection.clear();
    docs.forEach(doc => {
      if (doc.id && doc.vehicles) {
        this.docVehicleSelection.set(doc.id, new Set((doc.vehicles as any[]).map(v => v.id)));
      }
    });
  }

  isVehicleSelected(doc: any, vehicle: any): boolean {
    if (!doc || !doc.id) return true;
    const sel = this.docVehicleSelection.get(doc.id);
    return sel ? sel.has(vehicle.id) : true;
  }

  toggleVehicle(doc: any, vehicle: any, checked: boolean) {
    if (!doc || !doc.id) return;
    if (!this.docVehicleSelection.has(doc.id)) {
      this.docVehicleSelection.set(doc.id, new Set((doc.vehicles as any[]).map(v => v.id)));
    }
    const sel = this.docVehicleSelection.get(doc.id);
    if (checked) {
      sel.add(vehicle.id);
      // EEC-118: un vehículo marcado bajo un documento desmarcado no viajaba y la
      // pantalla decía lo contrario; marcar el vehículo marca también el documento.
      if (!this.selection.isSelected(doc) && !doc.generated) {
        this.selection.select(doc);
      }
    } else {
      sel.delete(vehicle.id);
    }
    this.selectionHasValue();
  }

  getSelectedDocuments(): any[] {
    return this.selection.selected
      .filter(doc => doc.exist)
      .map(doc => {
        const sel = this.docVehicleSelection.get(doc.id);
        const selectedVehicles = sel
          ? (doc.vehicles as any[]).filter(v => sel.has(v.id))
          : doc.vehicles;
        return { ...doc, vehicles: selectedVehicles };
      })
      .filter(doc => doc.vehicles && doc.vehicles.length > 0);
  }

  selectionHasValue() {
    const hasAny = this.selection.selected.some(doc => {
      if (!doc.exist) return false;
      const sel = this.docVehicleSelection.get(doc.id);
      return sel ? sel.size > 0 : (doc.vehicles && doc.vehicles.length > 0);
    });
    this.anySelect = !hasAny;
  }

  export(prev: boolean) {
    const data = this.form.value;
    data.id = this.defaults.values;
    data.language = this.clientLanguage;
    data.preview = prev;
    data.documents = this.getSelectedDocuments();
    this.commonService.reports<Base64>(this.service + '/export', data).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido exportar el archivo");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            if (prev) {

              Object.values(response.data).forEach(file => {

                var newFile = this.base64toBlob(file['base64'], file['mimeType']);
                const fileURL = URL.createObjectURL(newFile);
                  
                if (file['mimeType'] != 'application/vnd.ms-excel') {
                  
                  window.open(fileURL, '_blank');

                }
              });

            } else {

              Object.values(response.data).forEach(file => {
                
                var newFile = this.base64toBlob(file['base64'], file['mimeType']);
                var fileURL = URL.createObjectURL(newFile);
                var anchor = document.createElement("a");
                anchor.download = file['fileName'];
                anchor.href = fileURL;
                anchor.click();

              });

              this.dialogRef.close();
            }
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido exportar el archivo");
        }
    });
  }

  send() {
    this.form.get('sendMessage').setValue(this.form.get('sendMessage').value.replace(/\n/g, "<br>"));
    const data = this.form.value;
    data.id = this.defaults.values;
    data.documents = this.getSelectedDocuments();
    data.language = this.clientLanguage;
    this.commonService.reports<CommonListResponse<Document>>(this.service + '/send', data).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido enviar el archivo");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            this.alert.info("Informe enviado");
            this.dialogRef.close();
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido enviar el archivo");
        }
    });
  }

  history() {
    this.defaults.receivers = {
      client: this.client,
      broker: this.broker,
      user: this.user,
      brokerList: this.brokerList,
    };
    this.dialog.open(ReportsHistoryTableComponent, {
      data: this.defaults,
    });
  }

  base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }
}
